import { apiRequest } from "./common";

const getMeetingList = async (pageNo, pageSize, searchText) => {
    const response = await apiRequest('get', `/meeting?page=${pageNo}&limit=${pageSize}${searchText ? `&search=${searchText}` : ''}`);
    return response.data;
};

const getUpcomingMeeting = async () => {
    const response = await apiRequest('get', `/meeting/upcoming`);
    return response.data;
};

const createMeeting = async (data) => {
    const response = await apiRequest('post', `/meeting`, data);
    return response.data;
};

const updateMeeting = async (meetingId, data) => {
    const response = await apiRequest('put', `/meeting/${meetingId}`, data);
    return response.data;
};


const deleteMeeting = async (meetingId) => {
    const response = await apiRequest('delete', `/meeting/${meetingId}`);
    return response.data;
};

export {
    getMeetingList,
    getUpcomingMeeting,
    createMeeting,
    updateMeeting,
    deleteMeeting
}